import { FC } from "react";
import { SelectablePaymentMethodEnum } from "config/site";
import { Typography } from "ui-kit/Typography";
import { FlexCol, FlexRow } from "ui-kit/Layout/Flex";
import styles from "./PaymentMethod.module.css";
import classNames from "classnames";
import Gutter from "ui-kit/Gutter";
import { Glyph, Icon } from "ui-kit";
import Colors from "ui-kit/colors";

type PaymentMethodProps = {
  title: string;
  icon?: Glyph;
  logo?: JSX.Element;
  description?: string;
  type: SelectablePaymentMethodEnum;
  paymentMethod: SelectablePaymentMethodEnum;
  setPaymentMethod: (paymentMethod: SelectablePaymentMethodEnum) => void;
  children: JSX.Element;
};

const PaymentMethod: FC<PaymentMethodProps> = ({
  title,
  icon,
  logo,
  description,
  children,
  type,
  paymentMethod,
  setPaymentMethod,
}) => {
  const isSelected = paymentMethod === type;

  return (
    <div className={styles.item}>
      <button
        onClick={() => {
          setPaymentMethod(type);
        }}
        className={styles.button}
        aria-expanded={isSelected}
      >
        <FlexCol className={classNames(styles.clickableItem)}>
          <FlexRow alignItems="center">
            <div
              className={classNames(
                styles.circle,
                isSelected && styles.circleActive
              )}
            />
            <Gutter size={1.5} horizontal />
            <FlexCol>
              <FlexRow justifyContent="space-between" alignItems="center">
                <FlexRow alignItems="center">
                  <FlexRow style={{ width: 50, minWidth: 50 }}>
                    {icon && (
                      <Icon
                        name={icon}
                        size="M"
                        color={isSelected ? Colors.blue300 : Colors.grey500}
                      />
                    )}
                  </FlexRow>
                  <Typography color={isSelected ? "blue300" : "grey500"}>
                    <strong>{title}</strong>
                  </Typography>
                </FlexRow>
                {logo}
              </FlexRow>
              {description && (
                <>
                  <Gutter size={1} />
                  <Typography color="grey500">{description}</Typography>
                </>
              )}
            </FlexCol>
          </FlexRow>
        </FlexCol>
      </button>
      <div
        className={classNames(
          styles.component,
          isSelected && styles.componentActive
        )}
        aria-hidden={!isSelected}
      >
        <Gutter size={2} />
        <FlexCol>{children}</FlexCol>
      </div>
    </div>
  );
};

export default PaymentMethod;
